<sharry-header #header></sharry-header>
<div class="explore">
  <!--  <sharry-hero
    component="explore"
    [thumb]=""
    [showSignUp]="true"
    [backGroundImages]="heroImages"
    [h1Black]="true">
  </sharry-hero>-->
  <!-- Regions -->
  <section class="explore__regions-container">
    <section class="explore__regions">
      <div class="explore__regions__text">
        <h1 [innerHTML]="'explore.title' | i18next"></h1>
        <div class="explore__regions__search-place">
          <h2 class="black">{{ 'explore.subtitle' | i18next }}</h2>
          <mat-form-field appearance="outline">
            <input
              #autoCompleteInput
              aria-label="State"
              matInput
              placeholder="Luogo"
              type="text"
              [formControl]="whereValue"
              [matAutocomplete]="auto" />
            @if (whereValue?.value) {
              <button
                matIconSuffix
                mat-icon-button
                color="secondary"
                class="sharry-small"
                (click)="onRemoveDate()">
                <sharry-icon
                  matSuffix
                  name="x-circle-fill"
                  svgClass="search__icon&#45;&#45;show touchable"></sharry-icon>
              </button>
            }
            <button
              mat-icon-button
              matIconSuffix
              class="sharry-medium rounded sharry-inverted"
              color="primary"
              type="submit"
              (click)="onSearchByButton()">
              <sharry-icon registryName="magnifying-glass"></sharry-icon>
            </button>
            <mat-autocomplete
              #auto="matAutocomplete"
              class="explore__autocomplete">
              @if (options().length <= 0) {
                <mat-option>
                  <div
                    class="explore__autocomplete__near-location"
                    (click)="onLocationSearch()">
                    <img
                      alt="freccia cerca"
                      height="46"
                      ngSrc="./assets/icons/phosphor/freccia-cerca.svg"
                      width="40" />
                    <p class="semibold">{{ 'prefix-search.location' | i18next }}</p>
                  </div>
                </mat-option>
              }
              @for (option of options(); track option) {
                <mat-option
                  class="explore__autocomplete__location"
                  [value]="option.title"
                  (onSelectionChange)="onSearch($event)">
                  <sharry-icon
                    name="map-pin-line"
                    type="phosphor"
                    svgClass="svg-icon"></sharry-icon>
                  {{ option.title }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="italy"></ng-container>
    </section>
  </section>
  <!-- News -->
  <section class="explore__news">
    <!-- Categories -->
    <div class="explore__categories">
      @if (homepageCategories$ | async; as categories) {
        <div>
          <sharry-card-carousel
            class="lines-heights"
            [contents]="categories"
            [usePagination]="true"
            [carouselTitle]="'explore.categories.title'"
            [grid]="{ xs: 2, sm: 2, md: 5, lg: 6, xl: 7 }"
            [mode]="'template'"
            [itemTemplate]="category"></sharry-card-carousel>
          <ng-template
            #category
            let-item>
            <a
              class="explore__categories__figure"
              [routerLink]="['category' | routeTranslate, item.normalizedName]"
              [state]="{ refresh: true }">
              <figure>
                <img
                  fetchpriority="low"
                  class="explore__categories__icons"
                  height="80"
                  width="80"
                  [src]="item?.icon?.url"
                  alt="{{ item.name }}" />
                <figcaption>{{ item.name }}</figcaption>
              </figure>
            </a>
          </ng-template>
        </div>
      }
    </div>
  </section>
  <section class="explore__carousel-container">
    @if (latestPublicContents$ | async; as latest) {
      <sharry-card-carousel
        class="lines-heights"
        [contents]="latest"
        [usePagination]="true"
        [carouselTitle]="'homepage.explore.news.title'"
        [grid]="{ xs: 2, sm: 2, md: 3, lg: 4, xl: 4 }"
        [mode]="'template'"
        [itemTemplate]="news"></sharry-card-carousel>
    }
    <ng-template
      #news
      let-item>
      <a
        class="explore__news__card"
        [routerLink]="item | slug">
        <div class="explore__news__title">
          <figure>
            <img
              alt="tipologia"
              fetchpriority="low"
              height="56"
              width="56"
              src="https://media.sharry.land/app/images/families/ic-{{
                item.contentType === 'sharry' ? item.sharrySelection : item.contentType
              }}-card{{ $any(item)?.soldBySharryland ? '--sold-by-sharryland' : '' }}.webp" />
            <figcaption>
              <p
                class="bold"
                [innerHTML]="item | colorize: 'short'"></p>
              <small
                class="semibold"
                sharryEllipsisTooltip="1"
                >{{ item.shortAddress }}</small
              >
            </figcaption>
          </figure>
          <p
            class="bigger bold explore__news__title--top"
            [sharryEllipsisTooltip]="'2'">
            {{ item.title }}
          </p>
          <p
            class="explore__news__title--bottom"
            sharryEllipsisTooltip="1">
            @if (item?.contentType === 'wonder') {
              &nbsp;
            }
            @if (item?.contentType === 'sharry') {
              @if (!item?.freeSharryKind) {
                {{ 'explore.content-sharry.starting' | i18next }}&nbsp;<span
                  [innerHTML]="item?.nextUpcomingVariant?.price || 0 | htmlcurrency"></span>
              }
              @if (item?.freeSharryKind) {
                {{ item?.freeSharryKind | i18next }}
              }
              @if ([item.nextUpcomingVariant] | variantDate) {
                <span class="bold">&#8226;</span>
                <span class="medium">
                  {{ [item.nextUpcomingVariant] | variantDate | date: 'd MMM yyyy' }}
                </span>
              }
            }
            @if (item?.contentType === 'event') {
              @if (!!item?.nextEventInstance) {
                @if (item?.requiresPayment) {
                  {{ 'explore.payment' | i18next }}
                }
                @if (item?.requiresPayment) {
                  <span class="bold">&#8226;</span>
                }
                @if (!!item?.nextEventInstance && item?.nextEventInstance?.hasDates) {
                  <span class="medium">
                    {{ item?.nextEventInstance?.beginsAt | date: 'd MMM' }}
                    @if (!datesAreOnSameDay(item?.nextEventInstance?.beginsAt, item?.nextEventInstance?.endsAt)) {
                      -
                      {{ item?.nextEventInstance?.endsAt | date: 'd MMM' }}
                    }
                  </span>
                } @else {
                  <span>Tutto l'anno</span>
                }
              } @else {
                &nbsp;
              }
            }
          </p>
        </div>
        <picture class="explore__news__image">
          <img
            loading="lazy"
            [alt]="item.title"
            [src]="item.coverPicture?.bestVersion?.url"
        /></picture>
      </a>
    </ng-template>
  </section>

  <div class="explore__content">
    <section class="explore__hashtags">
      <h2>{{ 'explore.hashtags.title' | i18next }}</h2>
      <div class="explore__hashtags__carousel-container">
        <div class="explore__hashtags__list">
          @for (hashtag of hashtags$ | async; track hashtag.id; let i = $index) {
            <a
              class="explore__hashtags__list--box"
              [queryParams]="{
                prefix: 'title',
                value: '#' + hashtag.name,
              }"
              routerLink="{{ 'search-results' | routeTranslate }}">
              @if (!invalidImages.includes(i)) {
                <img
                  alt="hashtag"
                  src="https://media.sharry.land/app/images/esplora/hashtags/{{ hashtag.id }}.webp"
                  [width]="200"
                  [height]="200"
                  (error)="invalidImages.push(i)" />
              }
              <p>#{{ hashtag.name }}</p>
            </a>
          }
        </div>
      </div>
    </section>
  </div>
  <section class="explore__search-gallery">
    <div>
      <h2>{{ 'explore.search-gallery.title' | i18next }}</h2>
      <p>
        {{ 'explore.search-gallery.subtitle' | i18next }}
      </p>
      <sharry-search-gallery></sharry-search-gallery>
    </div>
  </section>

  <!--  <section class="explore__square-buttons">
    <h2>{{ 'explore.square-buttons.title' | i18next }}</h2>
    <div class="explore__square-buttons&#45;&#45;container">
      <div class="explore__square-buttons__carousel">
        @for (squareBox of squareBoxes; track squareBox.id; let i = $index) {
          @if (squareBox.button) {
            <button
              class="explore__square-buttons__carousel__box"
              (click)="onOpenSearchModal()">
              <p>{{ squareBox.title | i18next }}</p>
              <img
                height="auto"
                width="100%"
                alt="squareBox"
                src="https://media.sharry.land/app/images/esplora/square/{{ squareBox.id }}.png" />
            </button>
          } @else {
            <a
              class="explore__square-buttons__carousel__box"
              [queryParams]="squareBox?.scroll ? { prefix: 'scrollTo', value: squareBox?.scroll } : null"
              routerLink="{{ squareBox?.link | routeTranslate }}">
              <p>{{ squareBox.title | i18next }}</p>
              <img
                height="auto"
                width="100%"
                alt="squareBox"
                src="https://media.sharry.land/app/images/esplora/square/{{ squareBox.id }}.png" />
            </a>
          }
        }
      </div>
    </div>
  </section>-->
  @if ((userService.user$ | async) === null) {
    <section class="explore__sign-up">
      <h2>{{ 'explore.sign-up.title' | i18next }}</h2>
      <a
        mat-flat-button
        color="rainbow"
        class="sharry-xl rounded"
        sharryViewport="fade-in-2"
        [routerLink]="[]"
        [queryParams]="{ signup: true }">
        {{ 'sign-up.title' | i18next }}
      </a>
    </section>
  }
  @if (usingCapacitor) {
    <br />
  }
</div>

<ng-template #italy>
  @defer (on viewport) {
    <sharry-italy-map></sharry-italy-map>
  } @placeholder {
    <picture>
      <img
        loading="lazy"
        src="https://media.sharry.land/app/home-loggata/italy.webp"
        alt="italy" />
    </picture>
  }
</ng-template>

<sharry-footer class="is-not-mobile"></sharry-footer>
